/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { differenceInMinutes } from "date-fns";
import { DateTime } from "./datetime";

// Given the bookings that make up a batch, return the overall span:
// earliest start, latest end, and total duration in minutes.
// Returns null for fewer than 2 bookings (nothing to aggregate).
export const computeBatchSpan = (bookings) => {
  if (!Array.isArray(bookings) || bookings.length < 2) return null;

  const toDate = (value) => DateTime.parseMysqlDate(value);
  const sorted = bookings
    .filter((b) => b && b.start_datetime && b.end_datetime)
    .slice()
    .sort((a, b) => toDate(a.start_datetime) - toDate(b.start_datetime));

  if (sorted.length < 2) return null;

  const first = sorted[0];
  const last = sorted[sorted.length - 1];
  const duration = differenceInMinutes(toDate(last.end_datetime), toDate(first.start_datetime));

  return {
    startDatetime: first.start_datetime,
    endDatetime: last.end_datetime,
    duration: Number.isFinite(duration) && duration > 0 ? duration : null,
  };
};
